import React from 'react';

import { EmptyPage } from '../empty-page/EmptyPage';

export const Settings = () => {
  return <EmptyPage />;
};
